import React, { memo } from "react";
import { SmartFilter } from "./types";
import { cn } from "@/lib/utils";
import { Tooltip, TooltipTrigger, TooltipContent } from "../ui";

export const SmartFilterPill = memo(function SmartFilterPill({
  smartFilter,
  selected,
  onClick,
}: {
  smartFilter: SmartFilter;
  selected: boolean;
  onClick?: () => void;
}) {
  return (
    <Tooltip>
      <TooltipTrigger asChild={true}>
        <button
          className={cn(
            "h-10 cursor-pointer rounded-full border px-5 leading-9.5 focus:rounded-full",
            selected && "bg-button text-background",
          )}
          onClick={onClick}
          aria-selected={selected}
        >
          {smartFilter.name}
        </button>
      </TooltipTrigger>
      {smartFilter.tooltip && (
        <TooltipContent align={"start"} side={"bottom"}>
          {smartFilter.tooltip}
        </TooltipContent>
      )}
    </Tooltip>
  );
});
